import styled from 'styled-components';

export const Card = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;

export const OpenAIKeyInputDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const OpenAIKeyInput = styled.input`
  width: 100%;
  margin-right: 5px;
  padding: 5px;
`;

// Div around the project keys area
export const ProjectKeysContainer = styled.div`
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  padding-bottom: 50px;
`;

export const TaskTitle = styled.p`
  font-size: 16px;
  font-weight: bold;
`;

export const TaskDescription = styled.p`
  font-size: 14px;
`;

export const TaskInstructions = styled.ol`
  list-style-type: decimal;
  font-size: 14px;
  > li {
    margin-bottom: 1rem;
  }
`;

// Input for adding a new firestore project credentials
export const CredentialsTextArea = styled.textarea`
  width: 100%;
  height: 100px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  resize: none;
  white-space: nowrap;
  overflow: auto;
  margin-top: 5px;
`;

export const DeleteButton = styled.button`
  background-color: #e53e3e; /* red-600 */
  color: white;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #c53030; /* red-700 */
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.4); /* red focus ring */
  }
`;

export const DeleteBanner = styled.div`
  background-color: #fff5f5; /* red-50 */
  border: 1px solid #fed7d7; /* red-200 */
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  flex-direction: column;

  p {
    margin: 0;
    font-size: 14px;
    color: #742a2a; /* red-800 */
    flex: 1;
    margin-bottom: 10px;
  }
`;
